import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Button, Typography } from '@mui/material';
import { useShowWiFiConfiguration } from 'console/smart-config/show';
import { SmartConfigForm } from 'console/offline-pane/connect-to-wifi';
import { ColumnBox } from 'shared/components/containers';
export const Wifi = memo(function Wifi(props) {
    const { onFinish } = props;
    const show_smart_config = useShowWiFiConfiguration();
    if (!show_smart_config) {
        return (_jsxs(ColumnBox, { children: [_jsx(Typography, { color: "error", children: "\u041D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0447\u0435\u0440\u0435\u0437 SmartConfig." }), _jsx(Button, { color: "info", variant: "outlined", onClick: onFinish, children: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C" })] }));
    }
    return _jsx(SmartConfigForm, { open: true, onFinish: onFinish });
});
